import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getBloodProductAdministrationSelector } from '../selectors/bloodProductAdministration.selector'
import { IBloodProductAdministrationState } from '../store/bloodProductAdministration.types'
import { BloodProductAdministrationConstants } from '../store/bloodProductAdministration.constants'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setProcedureComplications() {
  try {
    const procedureState: IProcedureState = yield select(getProcedureStateSelector)
    const bloodProductAdministrationState: IBloodProductAdministrationState = yield select(
      getBloodProductAdministrationSelector
    )
    const { inputRows } = procedureState
    const { procedureComplications } = bloodProductAdministrationState
    inputRows.map((row) =>
      row.inputs.map((input) => {
        if (input.key === BloodProductAdministrationConstants.SET_PROCEDURE_COMPLICATIONS) {
          //@ts-ignore
          input.props.savedValues = procedureComplications
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setProcedureComplicationsSaga() error: ${e}`))
  }
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest(
    [BloodProductAdministrationConstants.SET_PROCEDURE_COMPLICATIONS],
    performWithMutexHOG,
    setProcedureComplications
  )
}
